export enum DashboardTabs {
  USER_ACTIVITY = 'User activity',
  META_DATA = 'Metadata',
  USER_GROUPS = 'Users',
  SYSTEM_ACTIVITY = 'System activity',
}
